import Breadcrumb from './breadcrumb';
import BreadcrumbItem from './breadcrumbItem';
export { BreadcrumbProps } from './breadcrumb';
export { BreadcrumbItemProps } from './breadcrumbItem';
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;
export { BreadcrumbItem }

